define('constant/common/map-with-default.constant',[], function () {

    return {
        //搜索关键词报表展现样式
        siteType:{
            'SEARCHLIST':'搜索排名',
            'FASTSEARCH':'搜索直达'
        },
        //搜索关键词报表匹配类型
        matchType:{
            'KEYMATCH':'关键词匹配',
            'AUTOMATCH':'自动匹配'
        },
        reportReturnDesc: {
            'NO_DATA': 1 //push报表无数据
        },
        testPayErrorFilter: {
            1:"商户侧签名验证失败",
            2:"商家url访问超时",
            3:"商家侧业务信息错误，如订单不存在",
            4:"商家存在IP放通名单限制，拒绝服务",
            5:"商家订单过期或者已经取消",
            94 :"尊敬的开发者，当前操作遇到异常无法完成，如需帮助请联系我们。",
            95 :"商家url无法访问，IO错误",
            96 :"商家提供的地址不是合法的url",
            97 :"商家返回的数据无法识别，请检查返回消息格式是否符合要求",
            98 :"商家返回参数错误",
            99:"商家url返回其他无法识别的异常"
        }

    }
});

